export function loadDataFromElement<T>(id: string, fallback: T): T {
  const element = document.getElementById(id);

  if (element && element.innerText && element.innerText !== '""') {
    return JSON.parse(element.innerText) as T;
  }
  return fallback;
}
